import { flowSegmentDataEndpoint } from 'endpoints';
import { singleRequestServiceFactory } from './request/singleRequestServiceFactory';

export const flowSegmentDataRest = singleRequestServiceFactory(flowSegmentDataEndpoint);

